import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { routeConfig } from '../../shared/common/constant';
import { useMutationHook } from '../../shared/hooks/useMutationHook';
import { AddCompanyBankDetailsQuery } from '../../shared/common/graphqlQuery';
import { companyData } from '../../core/auth';
import Modal from 'antd/lib/modal/Modal';
import { Button, Form, Input, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { validateLabelMessages } from '../../shared/hooks/utils';

const onError = (error: any) => {
    console.log(error, 'mymy');
}

const layout = {
    labelCol: {
        // span: 8,
    },
    wrapperCol: {
        // span: 16,
    },
};

const AddCompanyBankDetails = () => {
    const [visibleModal, setVisibleModal] = useState<boolean>(true);
    const [visibleAnotherModal, setVisibleAnotherModal] = useState<boolean>(false);
    const history = useHistory();
    const goToHome = () => {
        history.push(routeConfig.home.path);
    }

    useEffect(() => {
        if(!companyData().isCompanyExist()) {
            message.warn('No company found. Please Create a new Company.');
            history.push(routeConfig.createCompany.path);
        }
    }, []);

    const onSubmitted = (result: any) => {
        setVisibleModal(false);
        setVisibleAnotherModal(true);
    }

    const completedSteps = () => {
        setVisibleAnotherModal(false);
        goToHome();
    }
    const { callMutation, loading, error } = useMutationHook(AddCompanyBankDetailsQuery, onSubmitted, onError);

    const onFinish = (values: any) => {
        if(!loading) {
            const companyId = companyData().getCompanyData();
            callMutation({ variables: { bankInput: { ...values, companyId } } });
        }
    };
    const handleCancelModal = () => {
        setVisibleModal(false);
    }

    const handleCancelSecondModal = () => {
        setVisibleAnotherModal(false);
    }

    return (
        <div className="form-wrapper hide-close">
            <Modal title={
                <>
                    <h1 className="text-center mr-top-10">Let's get you setup</h1>
                    <h3 className="text-center">Add your company and work information</h3>
                </>
            } style={{ top: 20 }} width={820} visible={visibleModal} footer={null} onCancel={handleCancelModal}>
                <h2 className="formTitle">Step 3. Bank Details</h2>
                <Form {...layout} name="basic" layout="vertical" onFinish={onFinish} validateMessages={validateLabelMessages} validateTrigger='onSubmit'>
                    <Form.Item name='bankName' label="Bank Name" rules={[{required: true, whitespace: true }]}>
                        <Input autoComplete="off" size="large" />
                    </Form.Item>
                    <Form.Item name='acNumber' label="Account Number" rules={[{required: true, whitespace: true }]}>
                        <Input autoComplete="off" size="large" />
                    </Form.Item>
                    <Form.Item name='swiftCode' label="SWIFT Code" rules={[{required: true, whitespace: true },
                        {
                            pattern: /[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?/,
                            // pattern: /[0-9a-f]{1}/,
                            message: 'Please enter valid Swift Code'
                        }]}>
                        <Input autoComplete="off" size="large" />
                    </Form.Item>
                    <Form.Item name='accountName' label="Account Name" rules={[{required: true, whitespace: true }]}>
                        <Input autoComplete="off" size="large" />
                    </Form.Item>
                    <Form.Item name='address' label="Bank Address" rules={[{required: true, whitespace: true }]}>
                        <Input.TextArea />
                    </Form.Item>
                    <Form.Item wrapperCol={{ ...layout.wrapperCol }} className="text-center">
                        <Button size="large" type="primary" ghost htmlType="submit" style={{ width: '30%' }}>
                            {loading ? <LoadingOutlined style={{ fontSize: '20px' }} /> : 'Continue (3/3)'}
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
            <Modal title={
                <>
                    <h1 className="text-center mr-top-10">Let's get you setup</h1>
                    <h3 className="text-center">Add your company and work information</h3>
                </>
            } style={{ top: 20 }} width={820} visible={visibleAnotherModal} footer={null} onCancel={handleCancelSecondModal}>
                <h2 className="formTitle">~  Reminders ~</h2>
                <ul>
                    <li><h3> Add Product and HSN</h3></li>
                    <li><h3> Add Delivery Term</h3></li>
                    <li><h3> Add Product Name</h3></li>
                </ul>
                <div className="text-center mr-top-50">
                    <Button size="large" type="primary" ghost onClick={completedSteps} style={{ width: '30%' }}>
                        Get Set Go!
                    </Button>
                </div>
            </Modal>
        </div>
    );
}
export default AddCompanyBankDetails